<template>
  <div class="content">
    <form>
      <initial-form :datas="dataall"></initial-form>
      <firma></firma>
      <sklad :datas="dataall"></sklad>
      <paytype :datas="dataall"></paytype>
    </form>
    <b-modal id="modal-close" centered>
      <h4>
        {{$t('Sizda saqlanmagan malumotlar mavjud. Saqlansinmi?')}}
      </h4>

      <template #modal-footer="{ ok, cancel, hide }">
        <button type="button" class="btn btn-success" style="margin-bottom: 16px;"
          @click="$root.$refs.initial.Savedokument()">{{$t('Да')}}</button>
        <button type="button" class="btn btn-danger" @click='Home()'>{{$t('Нет')}}</button>
        <button type="button" class="btn btn-primary" @click="cancel()">{{$t('Отмена')}}</button>
      </template>
    </b-modal>
  </div>
</template>
<script>
// const InitialForm = () => import("@/pages/Initial/Form.vue");
import { InitialForm, Sklad, Firma, Paytype } from "@/pages";
export default {
  components: {
    InitialForm,
    Sklad,
    Firma,
    Paytype
  },
  watch: {
    dataall: {
      deep: true,
      handler(val, oldVal) {
        this.$store.state.saved += 1;
      }
    }
  },
  computed: {
    table() {
      return this.dataall.initial_balance_table;
    }
  },
  beforeRouteLeave(to, from, next) {
    if (this.$store.state.saved < 5) {
      this.$store.state.saved = null;
      localStorage.removeItem("prostatka");
      next();
      this.$store.state.selected_index = null;
    } else {
      this.$bvModal.show("modal-close");

    }
  },
  data() {
    return {
      watch: false,
      update_password: "",
      dataall:  {created_at: new Date()
          .valueOf()
          .toString()
          .slice(0, 10),
        create_time: new Date().toISOString().slice(0, 10),
        updated_at: new Date()
          .valueOf()
          .toString()
          .slice(0, 10),
        sklad_id: parseInt(localStorage.getItem("sklad_id")),
        user_id: parseInt(localStorage.getItem("user_id")),
        dollar_rate:0,
        pay_type_id: 1,
        summa: 0,
        debit_summa: 0,
        comment: "",
        number:0,
        count_all: 0,
        initial_balance_table: [
          {
            shtrix_kod:"",
            product: null,
            product_id: 0,
            count: 0,
            debit_price: 0,
            debit_summa:0,
            chakana_percent: 0,
            optom_percent: 0,
            chakana_price: 0,
            optom_price: 0,
            chakana_summa: 0,
            optom_summa: 0,
            pack_count:0,
            pack_price:0,
            pack_norma:0
          }
        ]}
    };
  },
  // async mounted() {
  //   let self = this;
  //   try {
  //     const response = await axios.get("api/v1/initial-balance/id/" + self.$route.params.id, {})
  //     if(response){
  //       self.dataall = response.data;
  //       self.dataall.created_at = new Date(self.dataall.created_at * 1000)
  //         .toISOString()
  //         .substr(0, 10);
  //     }

  //   } catch (error) {
  //     console.log(error)
  //   }

  // }
  methods: {
    Home() {
        this.$store.state.saved = null;
        this.$bvModal.hide('modal-close');
        this.$router.push({ name: "Начальный остаток" });
      },
    Data() {
      let self = this;
      axios
        .get("api/v1/initial-balance/id/" + self.$route.params.id, {})
        .then(function(response) {
          console.log(response.data.initial_balance_table[0].count);
          self.dataall = response.data;
          self.dataall.create_time = new Date(self.dataall.created_at * 1000)
            .toISOString()
            .substr(0, 10);
          setTimeout(() => {
            self.watch = true;
          }, 100);
        });
    },
    Sklad() {
      let self = this;
      axios
        .get("api/v1/sklads/id/" + localStorage.getItem("sklad_id"))
        .then(function(response) {
          self.update_password = response.data.update_password;
        });
    }
  },
  created: function() {
    this.Data();
    // this.Sklad();
  },
};
</script>
